// extracted by mini-css-extract-plugin
export default {"brandPromo":"JG-z","carousel":"KG-z"};